import React from 'react'
import IsomorphicStyleContext from 'isomorphic-style-loader-react18/StyleContext'
import useIsomorphicStyles from 'isomorphic-style-loader-react18/useStyles'
import type { SwanStyleSheetKey, SwanFontNameEnum } from '@vp/swan'

type CSSLoaderStyle = { [key: string]: string } & {
  _getCss: () => string
  _insertCss: () => () => void
  _getContent: () => [[string, string]]
}

export type Style = string | CSSLoaderStyle

export type InsertCss = (...styles: Style[]) => () => void

export const StyleContext: React.Context<{ insertCss: InsertCss }> =
  IsomorphicStyleContext

export const useStyles = (...styles: Style[]) => useIsomorphicStyles(...styles)

export const StyleContextProvider: React.Provider<{
  insertCss: InsertCss
}> = IsomorphicStyleContext.Provider

const SwanStyleRegistryContext = React.createContext({

  registerStyleKeys: (_keys: SwanStyleSheetKey[]) => {
    /**/
  },

  registerFontKeys: (_keys: SwanFontNameEnum[]) => {
    /* */
  },
})

export const SwanStyleRegistryProvider = SwanStyleRegistryContext.Provider

export const useSwanStyleKeys = (styleKeys: SwanStyleSheetKey[]) => {
  const context = React.useContext(SwanStyleRegistryContext)
  context.registerStyleKeys(['core', 'utility', ...styleKeys])
}

export const useSwanFontKeys = (fontKeys: SwanFontNameEnum[]) => {
  const context = React.useContext(SwanStyleRegistryContext)
  context.registerFontKeys(fontKeys)
}
